import Plyr from 'plyr'

let videoWrapper = null
let videoOverlay = null
let countdown = null
let btnPlayOrPause = null
let myInterval = null
let player = null
let elem = null
let isUseScroll = true
let isUseHover = true
let isTouchVideoWrapper = false
let isDisplayCountdown = false
let isDoneDisplayCountdown = false
let timeout = undefined
let interval = undefined
let i = 3
let players = []

let i18n = {
	restart: 'Khôi phục',
	rewind: 'Tua lại {seektime}s',
	play: 'Play',
	pause: 'Dừng',
	fastForward: 'Tua nhanh {seektime}s',
	seek: 'Seek',
	seekLabel: '{currentTime} of {duration}',
	played: 'Đang play',
	buffered: 'Đang tải',
	currentTime: 'Thời gian hiện tại',
	duration: 'Thời lượng',
	volume: 'Âm lượng',
	mute: 'Tắt tiếng',
	unmute: 'Mở tiếng',
	enableCaptions: 'Enable captions',
	disableCaptions: 'Disable captions',
	download: 'Tải về',
	enterFullscreen: 'Toàn màn hình',
	exitFullscreen: 'Thoát toàn màn hình',
	frameTitle: '{title}',
	captions: 'Captions',
	settings: 'Cài đặt',
	pip: 'PIP',
	menuBack: 'Go back to previous menu',
	speed: 'Tốc độ',
	normal: 'Bình thường',
	quality: 'Độ phân giải',
	loop: 'Lặp lại',
	start: 'Bắt đầu',
	end: 'Kết thúc',
	all: 'Tất cả',
	reset: 'Khôi phục',
	disabled: 'Disabled',
	enabled: 'Enabled',
	advertisement: 'Ad',
	qualityLabel: {
		0: 'Tự động',
	},
}

let isHandleSettingsPlyr = false

function processStream(elem, isLive = false, isLiveFirst = true, isPermissionSettingsPlyr = false) {
	try {
		if (player) {
			player = null
		}
		const hls = new Hls({
			debug: false,
		})
		let defaultOptions = {
			controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'settings','pip', 'fullscreen'],
			settings: ['quality'],
			fullscreen: {
				enabled: true,
				iosNative: false,
				
			},
		}

		const video = document.getElementById(elem)
		console.log('video', video);
		let source = ''
		if (video.firstElementChild) {
			source = video.firstElementChild.getAttribute('src')
		}
		if (!source.includes('.m3u8')) {
			video.src = source
			player = new Plyr(video, {
				...defaultOptions,
				i18n,
			})
			handleBtnPlay(player)
			players.push(player)
			window.players = players
			player.volume = 1
		} else {
			if (Hls.isSupported()) {
				// For more Hls.js options, see https://github.com/dailymotion/hls.js
				const hls = new Hls()
				hls.loadSource(source)
				// From the m3u8 playlist, hls parses the manifest and returns
				// all available video qualities. This is important, in this approach,
				// we will have one source on the Plyr player.
				hls.on(Hls.Events.MANIFEST_PARSED, function (event, data) {
					// Transform available levels into an array of integers (height values).
					const availableQualities = hls.levels.map((l) => l.height)
					availableQualities.unshift(0) //prepend 0 to quality array

					// Add new qualities to option
					defaultOptions.quality = {
						default: 0, //Default - AUTO
						options: availableQualities,
						forced: true,
						onChange: (e) => updateQuality(e),
					}
					// Add Auto Label
					defaultOptions.i18n = {
						qualityLabel: {
							0: 'Auto',
						},
					}
					hls.on(Hls.Events.LEVEL_SWITCHED, function (event, data) {
						var span = document.querySelector(".plyr__menu__container [data-plyr='quality'][value='0'] span")
						if (hls.autoLevelEnabled) {
							span.innerHTML = `AUTO (${hls.levels[data.level].height}p)`
						} else {
							span.innerHTML = `AUTO`
						}
					})
					let play_channel = document.querySelector('.player-channel')

					// Initialize new Plyr player with quality options
					if (!isLive) {
						// movie (hls)
						player = new Plyr(video, {
							...defaultOptions,
							i18n,
						})
						handleBtnPlay(player)
						players.push(player)
						window.players = players
						player.volume = 1
					} else {
						player = new Plyr(video, {
							...defaultOptions,
							i18n,
						})
						handleBtnPlay(player)
						players.push(player)
						window.players = players

						player.volume = 1
					}

					if (play_channel) {
						let plyr_controls = play_channel.querySelector('.plyr__controls')
						if (!isLive) {
							// catchup
							player.play()
							play_channel.querySelector('.plyr__controls__item.plyr__progress__container').classList.remove('hidden')
							play_channel.querySelector('.plyr__controls__item.plyr__time--current.plyr__time').classList.remove('hidden')
							play_channel.querySelector('.plyr__controls').classList.remove('relative', '!p-[10px]')
							play_channel.querySelector('.plyr__controls__item.plyr__control[data-plyr="play"]').classList.remove('!absolute', 'left-[80px]', 'top-1/2', 'transform', '-translate-y-1/2')
							if (plyr_controls.querySelector('.liveHtml')) {
								plyr_controls.querySelector('.liveHtml').remove()
							}
							if (!isHandleSettingsPlyr) {
								handleSettingsPlyr()
								isHandleSettingsPlyr = true
							}
						} else {
							// live
							if (!isLiveFirst) {
								player.play()
							}
							play_channel.querySelector('.plyr__controls__item.plyr__progress__container').classList.add('hidden')
							play_channel.querySelector('.plyr__controls__item.plyr__time--current.plyr__time').classList.add('hidden')
							play_channel.querySelector('.plyr__controls').classList.add('relative', '!p-[10px]')
							play_channel.querySelector('.plyr__controls__item.plyr__control[data-plyr="play"]').classList.add('!absolute', 'left-[80px]', 'top-1/2', 'transform', '-translate-y-1/2')

							let liveHtml = '<span class="plyr__controls__item plyr_control liveHtml block pl-3 relative"><span class="absolute left-0 top-1/2 transform -translate-y-1/2 w-2 h-2 bg-primary rounded-full"></span>Live</span>'
							plyr_controls.insertAdjacentHTML('afterbegin', liveHtml)
							if (!isHandleSettingsPlyr) {
								handleSettingsPlyr()
								isHandleSettingsPlyr = true
							}
						}
					} else {
						if (isPermissionSettingsPlyr) {
							handleSettingsPlyr()
						}
					}
				})
				hls.attachMedia(video)
				window.hls = hls
			} else if (video.canPlayType('application/vnd.apple.mpegurl')) {
				video.src = source
				video.play()
			}
		}
		function updateQuality(newQuality) {
			if (newQuality === 0) {
				window.hls.currentLevel = -1 //Enable AUTO quality if option.value = 0
			} else {
				window.hls.levels.forEach((level, levelIndex) => {
					if (level.height === newQuality) {
						console.log('Found quality match with ' + newQuality)
						window.hls.currentLevel = levelIndex
					}
				})
			}
		}

		function handleSettingsPlyr() {
			let video_wrappers = document.querySelectorAll('.video-wrapper')
			video_wrappers.forEach((video_wrapper) => {
				let plyr_menu = video_wrapper?.querySelector('.plyr__controls__item.plyr__menu')
				if (plyr_menu) {
					let plyr__menu__container = plyr_menu?.querySelector('.plyr__menu__container')
					if (plyr__menu__container) {
						plyr__menu__container?.firstChild?.firstChild?.remove()
						plyr__menu__container?.firstChild?.firstChild?.removeAttribute('hidden')
						plyr_menu?.querySelector('.plyr__control--back')?.remove()
						let p_html = '<p class="text-center text-sm pb-2 border-b border-gray-200 pt-2 cursor-default">Độ phân giải</p>'
						plyr__menu__container?.firstChild?.firstChild?.insertAdjacentHTML('afterbegin', p_html)
					}
				}
			})
		}
		function handleBtnPlay(player) {
			player.on('play', (event) => {
				Object.assign(video.closest('.video-wrapper').querySelector('.plyr__controls').style, {
					display: 'flex',
				})

				Object.assign(video.closest('.video-wrapper').querySelector('.plyr__control.plyr__control--overlaid').style, {
					display: 'none',
				})
			})
		}
	} catch (e) {}
}

export default processStream
